import React from 'react';
import { Divider, Input } from 'antd';
import { Form } from '..';
import Wrapper from './style';

const Index = () => {
  return (
    <Wrapper>
      <Divider />
      <div className="black1 font-subtitle2_medium">
        Additional Bio (Optional)
      </div>
      <div className="component_additional_bio_forms">
        <Form.Item name="education_institutions" label="Education Institution">
          <Input placeholder="Education Institution" />
        </Form.Item>
        <Form.Item name="expertises" label="Expertise">
          <Input placeholder="Expertise" />
        </Form.Item>
      </div>
      <div className="component_additional_bio_forms">
        <Form.Item name="past_job_titles" label="Past Job Title">
          <Input placeholder="Past Job Title" />
        </Form.Item>
        <Form.Item name="related_organization" label="Related Organization">
          <Input placeholder="Related Organization" />
        </Form.Item>
      </div>
      <div className="component_additional_bio_forms">
        <Form.Item name="hobbies" label="Hobbies">
          <Input placeholder="Hobbies" />
        </Form.Item>
        <Form.Item name="favorites" label="Favorites">
          <Input placeholder="Favorites" />
        </Form.Item>
      </div>
    </Wrapper>
  );
};

export default Index;
